import { Icon } from '../Icon/Icon';

interface Props {
  cols: {
    label: string;
    sort?: string;
    align?: string;
  }[];
  sort: {
    property: string;
    order: boolean;
  };
  changeSort(val: string | undefined): void;
}

function TableHeader({ cols, sort, changeSort }: Props) {
  return (
    <thead>
      <tr>
        {cols.map((el) => (
          <th key={el.label} style={{ textAlign: `${el.align === 'right' ? 'right' : 'left'}` }}>
            {el.sort ? (
              <button
                className={`table-btn${sort.order ? ' asc' : ''}`}
                type="button"
                onClick={() => changeSort(el.sort)}
              >
                {el.label}
                {sort.property === el.sort ? <Icon.Chevron className="icon-small" /> : null}
              </button>
            ) : (
              el.label
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
}

export default TableHeader;
